import { SgFormattedMessage } from '../../SgFormattedMessage';
import type { SgPickerItem } from './types';

type SummaryLabelProps = {
  color: string;
  selectedItems: SgPickerItem[];
};

export function SummaryLabel({ color, selectedItems }: SummaryLabelProps) {
  // Don't render anything if no items are selected
  if (selectedItems.length === 0) {
    return null;
  }

  return (
    <span className={`mt-1 me-2 mr-2 text-${color} fw-semibold font-weight-semibold`}>
      <SgFormattedMessage id="picker.itemsSelected" values={{ count: selectedItems.length }} />
    </span>
  );
}
